"use client"

import { ConnectWallet } from "@/components/connect-wallet"
import { QuickLinkGenerator } from "@/components/quick-link-generator"

export function AdminHeader() {
  return (
    <header className="sticky top-0 z-10 border-b border-border bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
      <div className="flex h-14 items-center justify-between px-6">
        <div />
        <div className="flex items-center gap-3">
          <QuickLinkGenerator />
          <ConnectWallet />
        </div>
      </div>
    </header>
  )
}
